module.exports = __webpack_public_path__ + "img/life.28433151.png";